import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/UpcomingEventsSection.css";
import apiUrl from "../config"; // import our dynamic API URL

function UpcomingEventsSection() {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        axios.get(`${apiUrl}/api/events`)
            .then(response => setEvents(response.data))
            .catch(error => console.error("Error fetching events:", error));
    }, []);

    return (
        <section className="luxury-container">
            <div className="upcoming-events-section">
                <div className="luxury-header">
                    <h2 className="events-title">Upcoming Events</h2>
                    <p className="events-description">
                        Create unforgettable moments with us
                    </p>
                </div>
                <div className="events-container">
                    {events.slice(0, 3).map((event, index) => (  // Only show 3 events
                        <div key={index} className="event-card">
                            <img
                                src={`${apiUrl}${event.image}`}
                                alt={event.title}
                                className="event-image"
                            />
                            <div className="event-details">
                                <h3 className="event-title">{event.title}</h3>
                                <p className="event-date">Date: {event.date}</p>
                                <p className="event-time">Time: {event.time}</p>
                                <button className="event-button" onClick={() => window.location.href = "/reserve"}>
                                    Book Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default UpcomingEventsSection;
